import styled from 'react-emotion';

const Header = styled('h5')`
  color: white;
  margin: 0;
  padding: 5px;
  background: #ddd;
  font-family: monospace;
  font-weight: normal;
  text-align: ${props => props.textAlign}
`;

export default Header;
